import * as React from 'react';
import { Row, Col, NavItem, Nav, NavLink, TabContent, TabPane, ToastBody, ToastHeader, Toast } from 'reactstrap';
import Page from '../Page';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { AffiliateReporting, Afr, DimensionReference, existAffiliateFactsInTable, existFactsInTable, FactTableRow, generateAffiliateNoDataState, getSelectedAffiliateReport, getSelectedAfr, getTable } from '../../redux/AfrSlice';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import FactEditor from '../feature/FactEditor';
import utilityHelper from '../../utils/utilityHelper';
import enums from '../../utils/enums';
import UploadDocumentByRole from '../feature/UploadDocumentByRole';
import { useState } from 'react';
import { RowDimensionEditorGrid } from '../core/RowDimensionEditorGrid';
import { RowConceptAndDimensionEditorGrid } from '../core/RowConceptAndDimensionEditorGrid';
import { getSelectedAffiliateEntityCode } from '../../redux/AffiliateSlice';
import SupplementalEditorGrid from '../core/SupplementalEditorGrid';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { RowDimensionNoDataCheckBox } from '../core/RowDimensionNoDataCheckBox';

const AffiliatedEntitySupplementalDetail = () => {
    const dispatch = useAppDispatch();

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const affiliateCode = useAppSelector(getSelectedAffiliateEntityCode);
    const currentAffiliatedEntity: AffiliateReporting | null | undefined = getSelectedAffiliateReport(currentAfr, affiliateCode);
    const affiliateName: string = (currentAffiliatedEntity && currentAffiliatedEntity.affiliateReference ? currentAffiliatedEntity.affiliateReference.name : "");

    var style = "auditDetail";
    var title = "Supplemental Information for " + affiliateName + " (" + affiliateCode + ")";

    function showSupplementalInfo() {
        return true;
    }

    const fetchFactState = function (): any {
        var fstate: boolean = false;
        if (currentAfr) {
            fstate = existAffiliateFactsInTable(currentAfr, affiliateCode, ["uas_064a_projects"]);
        }
        return fstate;
    }
   /* Tabs logic */
    const [activeTab, setActiveTab] = useState("1");
    const [hasFacts, setHasFacts] = useState(fetchFactState);
    const [hasFactsGrid, setHasFactsGrid] = useState(true);
    const [noDataGrid, setNoDataGrid] = useState(true);

    const fetchNoData = function () {
        var newState: any = generateAffiliateNoDataState(currentAfr, affiliateCode, "workState_noConstructionProjects");
        return newState;
    }
    const [noData, setNoData] = useState<any>(fetchNoData());

    const updateNoData = function (newState: any) {
        if (noData["workState_noConstructionProjects"] === newState["workState_noConstructionProjects"]) {
            return;
        }
        setNoData(newState);
    }

    const updateHasFacts = function (newState: any) {
        setHasFacts(newState["uas_064a_projects"]);
   }



    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }

    React.useEffect(() => {

        // Saving pending changes to AfrSlice
        utilityHelper.saveDeferredChanges(dispatch);
    }, [activeTab]);

    React.useEffect(() => {

        // Saving pending changes to AfrSlice
        var bProjectFacts = false;
        var tData: any[] = [];
        if (currentAfr) { //&& !noProjectsDeclared) {
            var tbl = getTable(currentAfr, "uas_064a_projects");
            if (tbl) {
                tbl.rows.map((tblRow: FactTableRow) =>
                    tblRow.dimensions.map((dim: DimensionReference) => {
                        if (dim.member && dim.member.code === affiliateCode) {
                            tData.push(tblRow);
                        }
                    })
                )
            }
        }
        if (tData && tData.length > 0) {
            bProjectFacts = true;
        }
        setHasFacts(bProjectFacts);
    }, [currentAfr,affiliateCode]);



    /* ********************************************** */
    return (
        <div>
            {showSupplementalInfo() ?
                (<Toast className={style}>
                    <ToastHeader className={style}>{title}</ToastHeader>
                    <ToastBody className={style}>
                        <Row>
                            <Col>
                                <>
                                    <Nav tabs>
                                        <NavItem>
                                            <NavLink
                                                className={activeClass('1')}
                                                onClick={() => { toggle('1'); }}
                                            >
                                                <b>Compensation</b>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={activeClass('2')}
                                                onClick={() => { toggle('2'); }}
                                            >
                                                <b>Construction Projects</b>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={activeClass('3')}
                                                onClick={() => { toggle('3'); }}
                                            >
                                                <b>Budget Variance</b>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <Row>
                                                <Col>
                                                    <SupplementalEditorGrid
                                                        tableName="uas_065a_compensation"
                                                        affiliateCode={affiliateCode}
                                                        gridData={[]}
                                                        gridColumns={[]}
                                                        gridOptions={{}}
                                                        gridId={"affiliateCompensation"}
                                                    />
                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <Row>
                                                <Col>
                                                    <RowDimensionNoDataCheckBox
                                                        componentTitle="Construction Projects"
                                                        tableName="uas_064_projects"
                                                        affiliateCode={affiliateCode}
                                                        noDataState="workState_noConstructionProjects"
                                                        gridId={"independentConstructionCB_" + affiliateCode}
                                                        taxonomyType={TaxonomyTypeEnum.AFR}
                                                        hasFacts={hasFacts}
                                                        noData={noData}
                                                        updateNoData={updateNoData}
                                                    />
                                                    <RowDimensionEditorGrid
                                                        componentTitle="Construction Projects"
                                                        tableName="uas_064a_projects"
                                                        affiliateCode={affiliateCode}
                                                        noDataState="workState_noConstructionProjects"
                                                        gridData={[]}
                                                        gridColumns={[]}
                                                        gridOptions={{}}
                                                        gridId={"affiliateConstruction_" + affiliateCode}
                                                        dimensionFilter={[]}
                                                        taxonomyType={TaxonomyTypeEnum.AFR}
                                                        noData={noData}
                                                        updateHasFacts={updateHasFacts}
                                                    />
                                                </Col>
                                            </Row>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <Row>
                                                <Col>
                                                    <br />
                                                    <p>
                                                        Per 218.32(1)(e)3., F.S., any district amending a final adopted budget must include a budget variance report. Would you like to upload a budget variance report?
                                                </p>
                                                    <UploadDocumentByRole containerParentOfAudit={currentAffiliatedEntity} role={enums.documentRole.budget_variance_report} pdfType={enums.pdfType.AEBudgetVarianceReport} showCheckbox={true} />
                                                </Col>
                                            </Row>
                                        </TabPane>
                                    </TabContent>
                                </>
                            </Col>
                        </Row>

                    </ToastBody>
                </Toast>)
                : (<div></div>)
            }
        </div>
    );
}

export default AffiliatedEntitySupplementalDetail;